import React from 'react';
import { I18n, Trans } from 'react-i18next';


export class AmalBedjaoui extends React.Component {
  render() {
    
    return (
      <I18n ns="translations">
        {
          (t, { i18n }) => (
             <section id="amal-section">
                <div className="container">
                  <div className="row" >
                    <div className="col-md-4 col-xs-12 amal-img">
                      <img src="images/img-amal.png"/>
                    </div>
                    <div className="col-md-8 col-xs-12 content-part">
                      <h3>{t('amalhaad')}</h3>
                      <p>{t('amalpara1')}<b className="bold"> {t('amalbold1')} </b> {t('amalparal1')} <b className="bold"> {t('amalparal2')} </b> {t('amalparal3')} </p>
                      <p>{t('amalpara2')}<b className="bold"> {t('amalbold2')} </b> {t('amalpara3')} </p>
                      <ul className="social-link">
                        <li><a href="https://twitter.com/amalbedjaoui?lang=fr" target="_blank"><img src="images/rs_twitter_rose.png"/></a></li>
                        <li><a href="https://www.linkedin.com/in/hapiwine/" target="_blank"><img src="images/rs_linkedin_rose.png"/></a></li>
                        <li><a href="https://fr.wikipedia.org/wiki/Amal_Bedjaoui" target="_blank" className="btn btn-default btn-style">{t('amalbutton')}</a></li>
                      </ul>
                    </div>
                  </div>

                 
              
                  <div className="row" id="card-amal">
                    <h4><i>{t('learnpage')}</i></h4>
                    <div className="card-amal-col">
                    <a href="http://www.vma.fr/fiche.cfm/385049_amal-bedjaoui" target="_blank">
                      <img className="card-amal-img" src="images/card_amal_01.png"/>
                      <h5>Voyez mon <br/> agent</h5>
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                   </a>
                    </div>
                    <div className="card-amal-col">
                    <a href="http://www.startupleadership.fr/" target="_blank">
                      <img className="card-amal-img" src="images/card_amal_02.png"/>
                      <h5>Startup Leadership Program</h5>
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                    <div className="card-amal-col">
                    <a href="http://www.ionis361.com/startup-incubateur-ionis.php" target="_blank">
                      <img className="card-amal-img" src="images/card_amal_03.png"/>
                      <h5>{t('learnpageimg3')} <br/>{t('learnpageimgl3')}</h5>
                      <img className="red-arrow" src="images/ic-arrow.png"/>
                    </a>
                    </div>
                  </div>
                </div>
              </section>
              )
            }
        </I18n>
       )
     }
}


// WEBPACK FOOTER //
// ./src/components/Propos/AmalBedjaoui/AmalBedjaoui.js